const initialState = {
  paymentInitData: 0,
};

const actions = {
  SET_PAYMENT_INIT_DATA: 'checkout/SET_PAYMENT_INIT_DATA',
};

export const CheckoutReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }
  if (action.type === actions.SET_PAYMENT_INIT_DATA) {
    return {
      ...state,
      paymentInitData: action.payload,
    };
  } else {
    return state;
  }
};

export const setPaymentInitData = (data) => ({
  type: actions.SET_PAYMENT_INIT_DATA,
  payload: data,
});

export default CheckoutReducer;
